import styled from 'styled-components';

import $Icon from 'components/Icon';

const iconWrapperBase = `
  border: 1px solid #595858;
  display: flex;
  align-items: center;
  height: 56px;
  width: 56px;
  padding: 3px;
  border-radius: 3px;
  margin: 3px 5px 3px 0;
`;

export const CheckmarkIconWrapper = styled.div`
  ${iconWrapperBase}
  color: #595858;
  ${({size}) => (size === 'small' ? 'height: 30px; width: 30px;' : '')}
`;

export const CloseIconWrapper = styled.div`
  ${iconWrapperBase}
  ${({size}) => (size === 'small' ? 'height: 30px; width: 30px;' : '')}
`;

export const IconsWrapper = styled.div`
  display: flex;
  postion: relative;
  justify-content: ${({position}) => (position === 'left' ? 'flex-start' : 'center')};
  margin: ${({position}) => (position === 'left' ? '0 0 0 0' : '0 0 15px 15px')};
`;

export const CheckmarkIcon = styled($Icon)`
  height: ${({size}) => (size === 'small' ? '15px' : '25px')};
  margin: auto;
`;

export const CloseIcon = styled($Icon)`
  height: ${({size}) => (size === 'small' ? '8px' : '12px')};
  margin: auto;
`;

export const FadeOutEffect = styled.div`
  background: #fff;
  opacity: 0.8;
  position: absolute;
  height: 60px;
  width: 125px;
  ${({size}) => (size === 'small' ? 'height: 35px; width: 75px;' : '')}
`;
